/**
 * Created by camiel on 25/04/2017.
 */

interface IColorOffset {
  red: number;
  green: number;
  blue: number;
}

export default IColorOffset;

export function darken(colorOffset: IColorOffset, ratio: number): IColorOffset {
  const multiplier = (1 - ratio) * 255;

  return {
    blue: (colorOffset.blue / 255) * multiplier,
    green: (colorOffset.green / 255) * multiplier,
    red: (colorOffset.red / 255) * multiplier,
  };
}



// WEBPACK FOOTER //
// ./src/IColorOffset.ts